<template>
  <div class="ui small modal" id="reservationModal">
    <i class="close icon"></i>
    <div class="header">
      Reservation Details
    </div>
    <div class="content" v-if="reservation">
      <div class="ui grid">
        <div class="ui eleven wide column">
          <div class="ui top attached segment">
            <h4>{{ reservation.contact.title }} {{ reservation.contact.firstName }} {{ reservation.contact.lastName }}</h4>
            <p>
              <span v-if="reservation.contact.company">Company: {{ reservation.contact.company }}<br></span>
              Email: {{ reservation.contact.email }}<br>
              Telephone: {{ reservation.contact.tel }}<br>
              Address: {{ reservation.contact.address }}<br>
              City: {{ reservation.contact.city }}, {{ reservation.contact.zip }}<br>
            </p>
            <div v-if="reservation.contact.comments">
              <h5>Comments</h5>
              <p>{{ reservation.contact.comments }}</p>
            </div>
          </div>
          <table class="ui bottom attached basic table">
            <tbody>
            <tr v-for="booking in reservation.bookings">
              <td>
                {{ reservation.boat.name }}
              </td>
              <td>
                <span v-if="boat && boat.startsAtHalfHour">
                  {{ (parseInt(booking.hour.split(' - ')[0]) - 1) + ':30' }} - {{ (parseInt(booking.hour.split(' - ')[1]) - 1) + ':30' }} h
                </span>
                <span v-else>
                  {{ booking.hour }} h
                </span>
              </td>
              <td>
                {{ moment(booking.date).format('ll') }}
              </td>
              <td class="right aligned">
                €{{ booking.cost }}.00
              </td>
            </tr>
            <tr v-for="service in reservation.services">
              <td colspan="3">
                {{ service.title }}
                <span v-if="service.priceType === 'perPerson' && service.people">x{{ service.people }}</span>
                <span v-if="!service.billed">(not billed)</span>
              </td>
              <td class="right aligned">
                <span v-if="!service.billed">€0.00</span>
                <span v-else-if="service.priceType === 'perPerson' && service.people">
                  €{{ numeral(service.price * service.people).format('0,00.00') }}
                </span>
                <span v-else>
                  €{{ numeral(service.price).format('0,00.00') }}
                </span>
              </td>
            </tr>
            <tr v-if="reservation.discount">
              <td colspan="4"><strong>Voucher:</strong> {{ reservation.discount.voucher }}</td>
            </tr>
            <tr v-if="reservation.discount && reservation.discount.absolute > 0">
              <td colspan="3"></td>
              <td class="right aligned">- €{{ reservation.discount.absolute }}.00</td>
            </tr>
            <tr v-if="reservation.discount && reservation.discount.percentage > 0">
              <td colspan="3"></td>
              <td class="right aligned">- {{ reservation.discount.percentage * 100 }}%</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3"><strong>Total</strong></th>
              <th class="right aligned">
                <strong>€{{ paymentTotal }}</strong>
              </th>
            </tr>
            </tfoot>
          </table>
          <div class="ui header">Additional Services</div>
          <table class="ui basic table">
            <tbody>
              <tr v-for="service in reservation.services">
                <td>
                  {{ service.title }}
                </td>
                <td>
                  <div class="ui mini labeled input" v-if="service.priceType === 'perPerson'">
                    <div class="ui label">
                      P
                    </div>
                    <input type="number" v-model="service.people" style="width: 60px">
                  </div>
                </td>
                <td>
                  <div class="ui basic tiny button" @click="toggleBillStatus(service._id)">
                    <span v-if="service.billed"><i class="checkmark icon"></i> Billed</span>
                    <span v-else><i class="delete icon"></i> Off Bill</span>
                  </div>
                </td>
                <td class="collapsing">
                  <div class="ui dropdown">
                    <div class="text">
                      <span v-if="!service.status || service.status === 'pending'" class="pending service status"><i class="wait icon"></i> Pending</span>
                      <span v-if="service.status === 'inProgress'" class="in-progress service status"><i class="refresh icon"></i> In Progress</span>
                      <span v-if="service.status === 'delivered'" class="delivered service status"><i class="checkmark icon"></i> Delivered</span>
                      <span v-if="service.status === 'escalated'" class="problem service status"><i class="alarm outline icon"></i> Escalated</span>
                    </div>
                    <i class="dropdown icon"></i>
                    <div class="menu" @click.prevent>
                      <div class="item" @click.prevent.stop="serviceStatus(service._id, 'pending')"><i class="wait icon"></i> Pending</div>
                      <div class="item" @click.prevent.stop="serviceStatus(service._id, 'inProgress')"><i class="refresh icon"></i> In Progress</div>
                      <div class="item" @click.prevent.stop="serviceStatus(service._id, 'delivered')"><i class="checkmark icon"></i> Delivered</div>
                      <div class="ui divider"></div>
                      <div class="item" @click.prevent.stop="serviceStatus(service._id, 'escalated')"><i class="alarm outline icon"></i> Escalated</div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="ui header">Wishes</div>
          <table class="ui basic table">
            <tbody>
            <tr>
              <td>
                {{ reservation.wishes || "no additional wishes" }}
              </td>
              <td class="collapsing">
                <div class="ui dropdown" v-if="reservation.wishes">
                  <div class="text">
                    <span v-if="!reservation.wishesStatus || reservation.wishesStatus === 'pending'" class="pending service status"><i class="wait icon"></i> Pending</span>
                    <span v-if="reservation.wishesStatus === 'inProgress'" class="in-progress service status"><i class="refresh icon"></i> In Progress</span>
                    <span v-if="reservation.wishesStatus === 'takenCare'" class="delivered service status"><i class="checkmark icon"></i> Taken Care</span>
                    <span v-if="reservation.wishesStatus === 'escalated'" class="problem service status"><i class="alarm outline icon"></i> Escalated</span>
                  </div>
                  <i class="dropdown icon"></i>
                  <div class="menu" @click.prevent>
                    <div class="item" @click.prevent.stop="wishesStatus('pending')"><i class="wait icon"></i> Pending</div>
                    <div class="item" @click.prevent.stop="wishesStatus('inProgress')"><i class="refresh icon"></i> In Progress</div>
                    <div class="item" @click.prevent.stop="wishesStatus('takenCare')"><i class="checkmark icon"></i> Taken Care</div>
                    <div class="ui divider"></div>
                    <div class="item" @click.prevent.stop="wishesStatus('escalated')"><i class="alarm outline icon"></i> Escalated</div>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="ui header">Questions</div>
          <table class="ui basic table">
            <tbody>
            <tr>
              <td>
                {{ reservation.questions || "no additional questions" }}
              </td>
              <td class="collapsing">
                <div class="ui dropdown" v-if="reservation.questions">
                  <div class="text">
                    <span v-if="!reservation.questionsStatus || reservation.questionsStatus === 'pending'" class="pending service status"><i class="wait icon"></i> Pending</span>
                    <span v-if="reservation.questionsStatus === 'inProgress'" class="in-progress service status"><i class="refresh icon"></i> In Progress</span>
                    <span v-if="reservation.questionsStatus === 'takenCare'" class="delivered service status"><i class="checkmark icon"></i> Taken Care</span>
                    <span v-if="reservation.questionsStatus === 'escalated'" class="problem service status"><i class="alarm outline icon"></i> Escalated</span>
                  </div>
                  <i class="dropdown icon"></i>
                  <div class="menu" @click.prevent>
                    <div class="item" @click.prevent.stop="questionsStatus('pending')"><i class="wait icon"></i> Pending</div>
                    <div class="item" @click.prevent.stop="questionsStatus('inProgress')"><i class="refresh icon"></i> In Progress</div>
                    <div class="item" @click.prevent.stop="questionsStatus('takenCare')"><i class="checkmark icon"></i> Taken Care</div>
                    <div class="ui divider"></div>
                    <div class="item" @click.prevent.stop="questionsStatus('escalated')"><i class="alarm outline icon"></i> Escalated</div>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="ui five wide column">
          <div class="ui header">People:</div>
          <div class="ui segment">
            <div class="ui input" style="width: 100%">
              <input class="ui input" type="number" placeholder="Enter number" v-model="people">
            </div>
            <div class="ui fluid button" @click="savePeople"><i class="save icon"></i> Save</div>
          </div>
          <div class="ui header">Status:</div>
          <div class="ui segment">
            <div class="ui selection dropdown" style="width: 100%; min-width: 0">
              <i class="dropdown icon"></i>
              <div class="text">
                {{ reservation.status }}
              </div>
              <div class="menu">
                <div class="item" @click.prevent.stop="checkIn">Checked In</div>
                <div class="item" @click.prevent.stop="checkOut">Finished</div>
              </div>
            </div>
          </div>
          <div class="ui header">Payment:</div>
          <div class="ui segment">
            <div style="text-align: center; margin-bottom: 15px">To Pay: €{{ paymentTotal }}</div>
            <div class="ui selection dropdown" style="width: 100%; min-width: 0">
              <i class="dropdown icon"></i>
              <div class="text">
                <span v-if="reservation.payment.status === 'paid'">Paid</span>
                <span v-if="reservation.payment.status === 'unpaid'">Unpaid</span>
              </div>
              <div class="menu">
                <div class="item" @click.prevent.stop="paid">Paid</div>
                <div class="item" @click.prevent.stop="unpaid">Unpaid</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui icon cancel button">
        <i class="delete icon"></i> Close
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../../services/'

  export default {
    data() {
      return {
          bookings: [],
          people: null,
          moment: moment,
          numeral: numeral
      }
    },
    mounted() {
      $('#reservationModal').modal()
    },
    computed: {
      reservation() {
          return this.reservationProp
      },
      paymentTotal() {
        return numeral(this.reservation.payment.total).format('0,0.00')
      },
      boat() {
        return this.boats.find(b => b._id === this.reservation.bookings[0]._boat)
      }
    },
    watch: {
      reservation: function () {
        this.people = this.reservation.people
        setTimeout(() => {
          $('#reservationModal').modal('refresh')
          $('.ui.dropdown').dropdown()
        }, 100)
      }
    },
    methods: {
      checkIn() {
        this.closeDropdown()
        services.reservationService.patch(this.reservation._id, { 'status': 'checkIn' }).then(reservation => {
          toastr.success('Visitor checked in')
        })
      },
      checkOut() {
        this.closeDropdown()
        services.reservationService.patch(this.reservation._id, { 'status': 'checkOut' }).then(reservation => {
          toastr.success('Visitor has checked out')
        })
      },
      paid() {
        this.closeDropdown()
        services.reservationService.patch(this.reservation._id, { 'payment.status': 'paid' }).then(reservation => {
          toastr.success('Visitor has paid')
        })
      },
      unpaid() {
        this.closeDropdown()
        services.reservationService.patch(this.reservation._id, { 'payment.status': 'unpaid' }).then(reservation => {
          toastr.success('Visitor has paid')
        })
      },
      savePeople() {
        services.reservationService.patch(this.reservation._id, { 'people': this.people }).then(reservation => {
          toastr.success('Number of people saved')
        })
      },
      serviceStatus(serviceId, status) {
        $('.ui.dropdown').dropdown('hide')

        for (let service of this.reservation.services) {
          if (service._id === serviceId) service.status = status
        }

        services.reservationService.patch(this.reservation._id, { 'services': this.reservation.services }).then(reservation => {
          toastr.success('Service status updated')
        })
      },
      toggleBillStatus(serviceId) {
        for (let service of this.reservation.services) {
          if (service._id === serviceId) {
            if ('billed' in service) {
              service.billed = !service.billed
            } else {
              service.billed = true
            }
          }
        }

        services.reservationService.patch(this.reservation._id, { 'services': this.reservation.services }).then(reservation => {
          toastr.success('Service status updated')
        })
      },
      questionsStatus(status) {
        $('.ui.dropdown').dropdown('hide')

        services.reservationService.patch(this.reservation._id, { 'questionsStatus': status }).then(reservation => {
          toastr.success('Status of questions updated.')
        })
      },
      wishesStatus(status) {
        $('.ui.dropdown').dropdown('hide')

        services.reservationService.patch(this.reservation._id, { 'wishesStatus': status }).then(reservation => {
          toastr.success('Status of questions updated.')
        })
      },
      closeDropdown() {
        $('.ui.dropdown').dropdown('hide')
      }
    },
    props: [
        'reservationProp',
      'boats'
    ]
  }
</script>

<style scoped>
  .fluid.button {
    margin-bottom: 5px;
  }
  .pending.service.status {
    color: #ff7633;
  }
  .in-progress.service.status {
    color: #5571ff;
  }
  .delivered.service.status {
    color: #25973a;
  }
  .problem.service.status {
    color: #cd1b1c;
  }
</style>



// WEBPACK FOOTER //
// DetailsModal.vue?ad05ae6c